export class ForbiddenApiError extends Error {
  constructor() {
    super('Forbidden error occurred')
    Object.setPrototypeOf(this, ForbiddenApiError.prototype)
  }
}
